export default "__VITE_ASSET__D2O4K8NW__"